import './createRoom.css';
import { useContext, useState } from 'react';
import { Grid, Card, CardContent, TextField } from '@material-ui/core'
import Button from 'components/Styled/Button/Button';
import socketProvider from 'components/Provider/SocketProvider';
import { joinRoom } from 'services/socketEmitEvent';

function CreateRoom(props) {
    const socket = useContext(socketProvider);
    
    const initialState = {
        roomName: '',
        playerName: ''
    };
    const [state, setState] = useState(initialState);

    const onFieldChange = (e)=>{
        setState({
            ...state,
            [e.target.name]: e.target.value.replaceAll(' ', '')
        })
    }

    const createRoom = ()=>{
        if(state.roomName && state.playerName){
            joinRoom(socket, state.roomName, state.playerName);
        }
    }

    return(
        <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
            style={{ minHeight: '100vh' }}
        >
            <Card>
                <CardContent>
                    <h1 id="title">Créer une partie</h1>
                    <div>
                        <TextField 
                            name='roomName' 
                            label='Nom du salon'
                            variant="outlined"
                            color='secondary'
                            autoFocus
                            fullWidth
                            margin='dense'
                            onChange={onFieldChange}
                        />
                        <TextField 
                            name='playerName' 
                            label='Pseudo'
                            variant="outlined"
                            color='secondary'
                            fullWidth
                            margin='dense'
                            onChange={onFieldChange}
                        />
                        <Button
                            disabled={!state.roomName || !state.playerName}
                            onClick={createRoom}
                        >
                            Valider
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </Grid>
    )
}

export default CreateRoom;